import { pgTable, uuid, timestamp, index } from 'drizzle-orm/pg-core';
import { users } from './users';
import { roles } from './roles';

const schema = {
  id: uuid('id').defaultRandom().primaryKey(),
  user_id: uuid('user_id').notNull().references(() => users.id),
  role_id: uuid('role_id').notNull().references(() => roles.id),
  date_created: timestamp('date_created', { withTimezone: true, mode: 'date' }).defaultNow().notNull(),
}

/**
 * @ignore
 * @internal
 */
export const userRoles = pgTable(
  'UserRoles', 
  schema,
  (table) => [
    index('user_role_user_id_idx').on(table.user_id),
    index('user_role_role_id_idx').on(table.role_id),
    index('user_role_user_role_idx').on(table.user_id, table.role_id), // Composite index for user-role lookups
  ]
); 